<template>
  <div class="bottomDefalt" v-loading="loading">
    <div class="bottomDefalt-top">
      <div
        :class="
          energyType === 'cool'
            ? 'bottomDefalt-top-left ashComWrap'
            : 'bottomDefalt-top-leftWarm ashComWrap'
        "
      >
        <div class="comTitle borderRaduis10">
          <h4>能耗指标</h4>
        </div>
        <div
          :class="
            energyType === 'cool'
              ? 'comContentBox'
              : 'comContentBox bottomDefalt-top-leftWarm-content'
          "
        >
          <HeadTipsGroup
            v-if="energyType === 'cool' && eciData?.length"
            :listData="eciData"
            twoLine
          />
          <template v-else-if="energyType !== 'cool' && eciWarmData?.length">
            <HeadTipsGroup :listData="eciWarmData[0]" />
            <HeadTipsGroup :mutipleData="eciWarmData[1]" useMutipleParams />
          </template>
          <el-empty v-else class="empty" description="暂无数据"></el-empty>
        </div>
      </div>
      <div
        :class="
          energyType === 'cool'
            ? 'bottomDefalt-top-right ashComWrap'
            : 'bottomDefalt-top-rightWarm ashComWrap'
        "
      >
        <div class="comTitle borderRaduis10">
          <h4>能效指标</h4>
        </div>
        <div
          :class="
            energyType === 'cool'
              ? 'comContentBox bottomDefalt-top-rightWarm-content'
              : 'comContentBox bottomDefalt-top-right-content'
          "
        >
          <HeadTips
            v-if="energyType === 'cool' && eeiData?.length"
            :listData="eeiData"
            twoLine
            className="eeiHeadTips"
          />
          <DataPagination
            v-else-if="energyType !== 'cool' && eeiWarmData?.length"
            :listData="eeiWarmData"
            className="eeiWarmDataSwitch"
            useEfficiencyStyle
            :chartsId="assetId"
            :split-num="4"
          />
          <el-empty v-else class="empty" description="暂无数据"></el-empty>
        </div>
      </div>
    </div>
    <div v-if="energyType === 'cool'" class="bottomDefalt-bottom ashComWrap">
      <div class="comTitle borderRaduis10">
        <h4>主机负荷</h4>
      </div>
      <div class="comContentBox hostLoadPie">
        <template v-if="hostLoad?.length">
          <div
            class="pieContainer"
            :style="{ width: hostLoad.length === 1 ? '100%' : '' }"
            v-for="v in hostLoad"
            :key="v.name"
          >
            <div class="pieContent">
              <PublicEcharts
                :id="`${assetId}-${v.name}`"
                :chartsData="{ v }"
                :options="dealRingData(v)"
                usePropsOptions
              />
            </div>
            <div class="pieTitle">{{ v.name }}</div>
          </div>
        </template>
        <el-empty
          v-else
          class="empty"
          :image-size="100"
          description="暂无数据"
        ></el-empty>
      </div>
    </div>
  </div>
</template>
<script>
import DataPagination from "../DataPagination.vue";
import HeadTips from "@/components/HeadTips/HeadTips";
import HeadTipsGroup from "@/components/HeadTips/HeadTipsGroup";
import PublicEcharts from "@/components/PublicEcharts";
import api from "@/api";
import { getProjectVal, matchingParamsName } from "@/assets/js/utils";
export default {
  components: { HeadTips, HeadTipsGroup, PublicEcharts,DataPagination },
  name: "BottomDefault",
  props: {
    assetId: {
      type: String,
      default: "",
    },
    //空调模式：cool - 制冷， gc - 燃气制热， ec - 电制热， ac - 空气源热泵制热
    energyType: {
      type: String,
      default: "cool",
    },
  },
  data() {
    return {
      hostLoad: [], //主机负荷
      eciData: [], //能耗
      eciWarmData: [], //能耗
      eeiData: [], //能效
      eeiWarmData: [],
      loading: false,
    };
  },
  methods: {
    initData() {
      this.hostLoad = []; //主机负荷
      this.eciData = []; //能耗
      this.eciWarmData = []; //能耗
      this.eeiData = []; //能效
      this.eeiWarmData = []; //能效
    },
    dealRingData(data = {}) {
      const { value } = data;
      let optionDefault = {
        title: {
          text: "负荷率",
          x: "center",
          y: "40%",
          textStyle: {
            color: "#999",
            fontSize: 12,
            align: "center",
          },
          subtext: `${value}%`,
          subtextStyle: {
            fontSize: 14,
            color: "#999",
          },
        },
        tooltip: {
          show: false,
        },
        legend: {
          show: false,
        },
        color: ["#28CCCB", "#F4F6F7"],
        series: [
          {
            type: "pie",
            radius: ["40%", "60%"],
            cursor: "default",
            data: [
              {
                name: "负荷率",
                value,
                emphasis: {
                  disabled: true,
                },
              },
              {
                name: "总数",
                value: 100 - value,
                emphasis: {
                  disabled: true,
                },
              },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              show: false,
            },
          },
        ],
      };
      return optionDefault;
    },
    dealWarmEEI(data = []) {
      const newData = data.map((element) => {
        const obj = { nameDefault: "锅炉" };
        Array.isArray(element) &&
          element.forEach((item) => {
            const { name: childName = "", value, unit } = item;
            switch (childName) {
              case "name":
                obj.name = value;
                break;
              case "等效热功率":
                obj.realName = "等效热功率";
                obj.realValue = value;
                obj.realUnit = unit;
                break;
              case "效率":
                obj.echartsData = { name: childName, value };
                break;
              default:
                break;
            }
          });
        return obj;
      });
      return newData;
    },
    //能效指标
    async getEnergyEfficiencyIndicators(assetId = null) {
      return await api.ACRGetEnergyEfficiencyIndicators({
        projectId: getProjectVal("Id"),
        assetId: assetId,
        deviceType: "中央空调主机",
      });
    },
    //制热模式
    async getHeatingEnergyEfficiencyIndicators(assetId = null) {
      return await api.ACRGetHeatingEnergyEfficiencyIndicators({
        projectId: getProjectVal("Id"),
        assetId: assetId,
        deviceType: "锅炉",
        energyType: this.energyType,
      });
    },
    dealECI(data = []) {
      const newData = data.map((element) => {
        const { name, charts = [] } = element;
        const obj = { name };
        Array.isArray(charts) &&
          charts.forEach((item) => {
            const { name: childName = "", value, unit } = item;
            if (childName.includes("实时")) {
              obj.realName = childName;
              obj.realValue = value;
              obj.realUnit = unit;
            } else {
              obj.rateName = childName;
              obj.rateValue = value;
              obj.rateUnit = unit;
            }
          });
        return obj;
      });
      return newData;
    },
    dealWarmECI(data = []) {
      const newData = [[], { name: "锅炉机组", params: [] }];
      data.forEach((element) => {
        const { name, params = [] } = element;
        if (name === "锅炉机组") {
          const obj1 = {};
          const obj2 = {};
          //燃气
          if (this.energyType === "gc") {
            Array.isArray(params) &&
              params.forEach((item) => {
                const { name: childName = "", value, unit } = item;
                switch (childName) {
                  case "实时用气量":
                    obj1.realName = childName;
                    obj1.realValue = value;
                    obj1.realUnit = unit;
                    break;
                  case "机组实时效率":
                    obj1.rateName = childName;
                    obj1.rateValue = value;
                    obj1.rateUnit = unit;
                    break;
                  case "实时热量":
                    obj2.realName = childName;
                    obj2.realValue = value;
                    obj2.realUnit = unit;
                    break;
                  case "今日供热量":
                    obj2.rateName = childName;
                    obj2.rateValue = value;
                    obj2.rateUnit = unit;
                    break;
                  default:
                    break;
                }
              });
          } else {
            Array.isArray(params) &&
              params.forEach((item) => {
                const { name: childName = "", value, unit } = item;
                switch (childName) {
                  case "实时功率":
                    obj1.realName = childName;
                    obj1.realValue = value;
                    obj1.realUnit = unit;
                    break;
                  case "负荷率":
                    obj1.rateName = childName;
                    obj1.rateValue = value;
                    obj1.rateUnit = unit;
                    break;
                  case "实时热量":
                    obj2.realName = childName;
                    obj2.realValue = value;
                    obj2.realUnit = unit;
                    break;
                  case "今日供热量":
                    obj2.rateName = childName;
                    obj2.rateValue = value;
                    obj2.rateUnit = unit;
                    break;
                  default:
                    break;
                }
              });
          }
          newData[1].params = [obj1, obj2];
        } else {
          const obj = { name };
          Array.isArray(params) &&
            params.forEach((item) => {
              const { name: childName = "", value, unit } = item;
              if (childName.includes("实时")) {
                obj.realName = childName;
                obj.realValue = value;
                obj.realUnit = unit;
              } else {
                obj.rateName = childName;
                obj.rateValue = value;
                obj.rateUnit = unit;
              }
            });
          newData[0].push(obj);
        }
      });
      return newData;
    },
    //能耗指标
    async getEnergyConsumptionIndicators(assetId = null) {
      return await api.ACRGetEnergyConsumptionIndicators({
        projectId: getProjectVal("Id"),
        assetId: assetId,
        deviceType: "中央空调主机",
      });
    },
    //制热模式
    async getHeatingEnergyConsumptionIndicators(assetId = null) {
      return await api.ACRGetHeatingEnergyConsumptionIndicators({
        projectId: getProjectVal("Id"),
        assetId: assetId,
        deviceType: "锅炉",
        energyType: this.energyType,
      });
    },
    //主机负荷
    async getHostLoad(assetId = null) {
      return await api.ACRGetHostLoad({
        projectId: getProjectVal("Id"),
        assetId: assetId,
        deviceType: "中央空调主机",
      });
    },
    getData(assetId) {
      this.loading = true;
      this.initData();
      if (this.energyType === "cool") {
        const q1 = this.getEnergyEfficiencyIndicators(assetId);
        const q2 = this.getEnergyConsumptionIndicators(assetId);
        const q3 = this.getHostLoad(assetId);
        Promise.all([q1, q2, q3])
          .then((res) => {
            let res1 = res[0];
            if (res1 && res1.data.code == 200) {
              this.eeiData = res1.data.data.map((item) => {
                item.name = matchingParamsName(item.name);
                return item;
              });
            } else {
              console.log("获取能效指标失败");
            }
            let res2 = res[1];
            if (res2 && res2.data.code == 200) {
              this.eciData = this.dealECI(res2.data.data);
            } else {
              console.log("获取能耗指标失败");
            }
            let res3 = res[2];
            if (res3 && res3.data.code == 200) {
              this.hostLoad = res3.data.data.map((item) => ({
                name: item.name,
                value: item.value,
              }));
            } else {
              console.log("获取主机负荷失败");
            }
          })
          .catch((err) => {
            console.log("---getData---err----", err);
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        const q1 = this.getHeatingEnergyEfficiencyIndicators(assetId);
        const q2 = this.getHeatingEnergyConsumptionIndicators(assetId);
        Promise.all([q1, q2])
          .then((res) => {
            let res1 = res[0];
            if (res1 && res1.data.code == 200) {
              this.eeiWarmData = this.dealWarmEEI(res1.data.data);
            } else {
              console.log("获取能效指标失败");
            }
            let res2 = res[1];
            if (res2 && res2.data.code == 200) {
              this.eciWarmData = this.dealWarmECI(res2.data.data);
            } else {
              console.log("获取能耗指标失败");
            }
          })
          .catch((err) => {
            console.log("---getData---err----", err);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
  watch: {
    assetId: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        console.log("bottomDefault---assetId--", val, oldVal);
        // this.getEnergyEfficiencyIndicators(val)
        // this.getEnergyConsumptionIndicators(val)
        // this.getHostLoad(val)
        this.getData(val);
      },
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.bottomDefalt {
  width: 100%;
  margin-top: 12px;
  @include setFlexColumn;
  // height: 450px;

  &-top {
    @include setFlexBetween;
    height: 450px;

    &-left {
      flex-grow: 1;
      width: 1218px;
      margin-right: 12px;
    }

    &-right {
      width: 370px;
      flex-grow: 0;

      &-content {
        padding: 0 5px;
        width: calc(100% - 10px);
      }

      ::v-deep .eeiHeadTips > div .firstDiv .highlight {
        font-size: 22px;
      }
    }
    &-leftWarm {
      flex-grow: 1;
      width: calc(50% - 6px);
      margin-right: 12px;
      &-content {
        @include setFlexColumn;
        justify-content: space-around;
      }
    }

    &-rightWarm {
      width: calc(50% - 6px);
      flex-grow: 1;

      &-content {
        padding: 0 5px;
        width: calc(100% - 10px);
      }

      ::v-deep .eeiHeadTips > div .firstDiv .highlight {
        font-size: 22px;
      }
      ::v-deep .eeiWarmDataSwitch{
        height: 395px;
      }
    }
  }

  &-bottom {
    margin-top: 12px;

    // height: 365px;
    .hostLoadPie {
      @include setFlexAround;
      flex-wrap: wrap;

      .pieContainer {
        width: 200px;
        height: 210px;

        .pieContent {
          width: 170px;
          height: 170px;
          text-align: center;
        }

        .pieTitle {
          width: 170px;
          text-align: center;
          font-weight: bold;
          color: #333;
        }
      }

      .empty {
        height: 210px;
      }
    }
  }
  .borderRaduis10 {
    border-radius: 10px;
  }
}
</style>
